import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import ClusterSvg from '../svgs/ClusterSvg';
import { MAP_MAX_CLUSTER_COUNT } from '../../constants/config';
import { googleCoordinates } from '../../utils/googleCoordinates';
import { ClusterMotionAnimation } from './ClusterMotionAnimation';
export default function ParkingCluster({ position, counter, testId, onClick }) {
    const handleClick = () => {
        if (onClick)
            onClick();
    };
    return (_jsx(AdvancedMarker, { position: googleCoordinates(position), onClick: handleClick, className: "relative", children: _jsx("div", { "data-testid": testId, children: _jsxs(ClusterMotionAnimation, { children: [_jsx("div", { className: "absolute inset-0 flex items-center justify-center pb-0.5 text-base font-bold text-white", children: counter <= MAP_MAX_CLUSTER_COUNT ? counter : `${MAP_MAX_CLUSTER_COUNT}+` }), _jsx(ClusterSvg, {})] }) }) }));
}
